import { Reveal } from "@/components/Reveal";
import { Button } from "@/components/Button";

export function QuoteCTA() {
  return (
    <section className="relative overflow-hidden bg-ink py-20 lg:py-28 text-white" data-testid="final-cta">
      <div className="tech-grid-dark absolute inset-0" />
      <div className="absolute -right-20 top-1/2 hidden lg:block h-96 w-96 -translate-y-1/2 rotate-45 border border-amber/20" />
      <div className="relative mx-auto max-w-3xl px-4 sm:px-6 text-center">
        <Reveal>
          <span className="font-body text-xs font-semibold uppercase tracking-[0.28em] text-amber">Start your enquiry</span>
          <h2 className="mt-4 font-display font-bold uppercase leading-[0.95] tracking-tight text-[clamp(32px,4.5vw,60px)]">
            Let's Get the Right Part Moving
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-[clamp(16px,2vw,18px)] leading-relaxed text-white/70">
            Have a part number, machine model or replacement requirement? Send the details and start your enquiry with Ocean Exports.
          </p>
          <div className="mt-9 flex flex-wrap justify-center gap-4">
            <Button to="/request-a-quote" variant="accent" arrow data-testid="finalcta-quote-btn">Request a Quote</Button>
            <Button to="/contact" variant="outline" data-testid="finalcta-contact-btn">Contact Sales</Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
